<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'LabDips_Title' | translateWF: 'Lab Dips' }}
        </h1>
      </div>
    </div>
    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'LabDips_Title' | translateWF: 'Lab Dips'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>

        <p-card data-variant="compact">
          <p-table [value]="listLabDips()" (onSort)="onSort($event)" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="labDipNumber">
                  {{ 'LabDips_Number' | translateWF: 'Lab Dip Number' }}
                  <p-sortIcon field="labDipNumber" />
                </th>
                <th>
                  {{ 'LabDips_Color' | translateWF: 'Color' }}
                </th>
                <th>
                  {{ 'LabDips_Request' | translateWF: 'Lab Dip Request' }}
                </th>
                <th>
                  {{ 'LabDips_ProductDev' | translateWF: 'Product Dev' }}
                </th>
                <th>{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let labDip = getRowData(rowData);
              <tr class="cursor-pointer">
                <td>
                  <a (click)="labDip.id && openLabDipDetailsModal(labDip.id)">
                    {{ labDip.labDipNumber }}
                  </a>
                </td>
                <td>{{ labDip.colorDto?.name }}</td>
                <td>{{ labDip.labDipRequestNumber }}</td>
                <td>
                  <i *ngIf="labDip.isForProductDevelopment" class="pi pi-check text-green-500"></i>
                  <i *ngIf="!labDip.isForProductDevelopment" class="pi pi-times text-red-500"></i>
                </td>
                <td>
                  <p-button
                    icon="pi pi-ellipsis-v"
                    [text]="true"
                    [rounded]="true"
                    (onClick)="toggleMenu($event, labDip)"
                    [disabled]="!labDip.recipes || labDip.recipes.length === 0"
                  />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  {{ 'LabDips_Not_Found' | translateWF: 'Lab Dips not found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
  <p-menu #menu [model]="menuItems()" [popup]="true" appendTo="body" />
</main>
